import { render, staticRenderFns } from "./PublicStudy.vue?vue&type=template&id=4780cef6&scoped=true&"
import script from "./PublicStudy.vue?vue&type=script&lang=js&"
export * from "./PublicStudy.vue?vue&type=script&lang=js&"
import style0 from "./PublicStudy.vue?vue&type=style&index=0&id=4780cef6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4780cef6",
  null
  
)

export default component.exports